import React from 'react';
import PropTypes from 'prop-types';

/**
 * iconCell — factory for a cell renderer pairing a category icon with the
 * value. The icon is what tells a reader mid-scroll which column they are in
 * when the header has left the screen.
 *
 *   { field: 'type_of_company', cellRenderer: iconCell(MdCategory) }
 */
const iconCell = (Icon, iconClass = 'tw-text-slate-400') => {
  const Renderer = ({ value }) => {
    if (value == null || value === '') return null;
    return (
      <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-max-w-full">
        <Icon size={13} className={`${iconClass} tw-shrink-0`} />
        <span className="tw-truncate">{value}</span>
      </span>
    );
  };
  Renderer.propTypes = { value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) };
  return Renderer;
};

/**
 * valueIconCell — like iconCell, but the icon (and its tint) depends on the
 * cell value. `resolve(value)` returns `{ icon, className? }` or nothing
 * (→ plain text).
 *
 *   const TRIP = { domestic: { icon: LuMap, className: 'tw-text-emerald-500' } };
 *   { field: 'type_of_travel',
 *     cellRenderer: valueIconCell((v) => TRIP[String(v).toLowerCase()]) }
 */
export const valueIconCell = (resolve) => {
  const Renderer = ({ value }) => {
    if (value == null || value === '') return null;
    const match = resolve(value) || {};
    const Icon = match.icon;
    if (!Icon) return <span className="tw-truncate">{value}</span>;
    return (
      <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-max-w-full">
        <Icon size={13} className={`${match.className || 'tw-text-slate-400'} tw-shrink-0`} />
        <span className="tw-truncate">{value}</span>
      </span>
    );
  };
  Renderer.propTypes = { value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) };
  return Renderer;
};

export default iconCell;
